<template>
  <modal class="skintestblock" v-model="modal" :append-to-body="true" :backdrop="false" size="max">
    <div slot="header">
      <h4 class="smalltitle" slot="header">{{ doctor.fullName }}</h4>
      <button type="button" class="close" @click.prevent="modal = false" title="Close">×</button>
    </div>
    <div class="block-body">
      <div class="blockcont">
        <div class="prolabel">Reason</div>
        <div class="profield">
          <textarea v-model="reason"></textarea>
        </div>
      </div>
      <div class="blockcont">
        <div class="prolabel">File</div>
        <div class="profield">
          <div class="example-full">
            <div class="row">
              <div class="col-md-12">
                <div class="blockcont block-image">
                  <div class="upload-drop-zone drop-active" id="drop-zone-application-bio"
                       @click="triggerSelectFile"></div>
                  <label for="file" class="btn btn-lg btn-primary hide" id="selectFileLicense">Select
                    Files</label>
<!--                  <div style="text-align:center">-->
<!--                    <button class="btn" v-if="!$refs.uploadLicense || !$refs.uploadLicense.active"-->
<!--                            @click.prevent="clickUpload()">Upload-->
<!--                    </button>-->
<!--                    <button type="button" class="btn btn-danger" v-else-->
<!--                            @click.prevent="$refs.uploadLicense.active = false">-->
<!--                      Stop Upload-->
<!--                    </button>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
            <div class="upload">
              <div class="">
                <table class="table table-hover">
                  <thead>
                  <tr class="signed-form">
                    <th class="td-name">UPLOADED FILES</th>
                    <th class="td-action" style="text-align: right !important;">ACTIONS</th>
                  </tr>
                  </thead>
                  <tbody>
<!--                  <tr v-for="(file, index) in files" :key="file.id">-->
<!--                    <td class="td-name">-->
<!--                      <div class="filename">-->
<!--                        <img v-if="file.thumb" :src="file.thumb" width="40" height="auto"/>-->
<!--                        {{file.name}}-->
<!--                      </div>-->
<!--                    </td>-->
<!--                    <td class="td-action" style="text-align: right !important; min-height: 1px">-->
<!--                      <div class="td-action-process">-->
<!--                        <div class="progress" v-if="!file.error" style="min-height: 1px">-->
<!--                          <div-->
<!--                              :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}"-->
<!--                              role="progressbar" :style="{width: file.progress + '%'}">-->
<!--                            &nbsp;&nbsp;{{file.progress}}%-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <div class="error-text" v-if="file.error">{{file.response.msg}}</div>-->
<!--                      </div>-->
<!--                      <div class="td-action-delete" style="width: 10%; float: right">-->
<!--                                        <span class="delete-new-file"-->
<!--                                              @click.prevent="$refs.uploadLicense.remove(file)"><i-->
<!--                                            class="fa fa-times"></i></span>-->
<!--                      </div>-->
<!--                    </td>-->
<!--                  </tr>-->
                  <tr v-for="(file, index) in dataFiles" :key="file.name">
                    <td class="td-name">
                      <div class="filename">
                        <img v-if="file.thumb" :src="file.thumb" width="40" height="auto"/>
                        {{file.fileName}}
                      </div>
                    </td>
                    <td class="td-action" style="text-align: right !important; min-height: 1px">
                      <div class="td-action-process">
                        <div class="progress" v-if="!file.error" style="min-height: 1px">
                          <div
                              :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}"
                              role="progressbar" :style="{width: file.progress + '%'}">
                            &nbsp;&nbsp;{{file.progress}}%
                          </div>
                        </div>
                        <div class="error-text" v-if="file.error">{{file.response.msg}}</div>
                      </div>
                      <div class="td-action-delete" style="width: 10%; float: right">
                                        <span class="delete-new-file"
                                              @click.prevent="removeFile(index)"><i
                                            class="fa fa-times"></i></span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="example-foorer">
                <file-upload
                    name="file"
                    class="btn btn-primary dropdown-toggle hide"
                    :post-action="postAction"
                    :multiple="multiple"
                    :directory="directory"
                    :headers="headers"
                    :drop="drop"
                    :add-index="addIndex"
                    v-model="files"
                    :data="dataRequest"
                    @input-filter="inputFilter"
                    @input-file="inputFile"
                    ref="uploadLicense">
                </file-upload>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" class="btn btn-default" @click="clickUpload">
         Save
      </button>
      <button type="button" class="btn btn-default" @click="modal = false">Cancel</button>
    </div>
  </modal>
</template>

<script>
import config from '@/config'
import axios from '@/client'
import store from '@/store/store'
import moment from 'moment'
import Common from '../../mixins/Common'
const baseUrl = config.baseUrl
export default {
  name: 'DeactivateEPCSModal',
  mixins: [Common],
  components: {
    FileUpload: VueUploadComponent
  },
  props: {
    doctor: {
      required: false,
      default: null
    }
  },
  data () {
    return {
      modal: true,
      reason: '',
      files: [],
      dataFiles: [],
      postAction: baseUrl + '/doctor/deactivate-epcs/upload-file',
      multiple: true,
      directory: false,
      headers: {},
      autoCompress: 1024 * 1024,
      minSize: 0,
      uploadAuto: true,
      isOption: false,
      drop: true,
      dropDirectory: false,
      dataRequest: {
        reason: '',
        doctorId: ''
      },
      addIndex: false
    }
  },
  computed: {},
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  methods: {
    async inputFilter (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file)
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = ''
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob
        }
      }
      if (!newFile && oldFile) {
        if (oldFile.success && oldFile.response.data.id) {
          // remove
        }
      }
    },
    // add, update, remove File Event
    inputFile (newFile, oldFile) {
      if (newFile && !oldFile) {}
      if (newFile && oldFile) {
        // update
        if (newFile.active && !oldFile.active) {
          // beforeSend
          if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
            this.$refs.uploadLicense.update(newFile, { error: 'size' })
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
        }
        if (newFile.error && !oldFile.error) {
          // error
          let response = newFile.response
          if (response.s === 400) {

          }
        }
        if (newFile.success && !oldFile.success) {
          // create file
          if (store.state.timeOutLogin) {
            clearTimeout(store.state.timeOutLogin)
          }
          let timeOut = setTimeout(function () {
            store.commit('setOpenModalLogin', true)
          }, 540000)
          store.commit('setWorkingStatus', timeOut)
          if (newFile.response.s === 200) {
            let file = newFile.response.data
            file.progress = 100
            file.active = true
            this.dataFiles.push(file)
            // this.modal = false
            let vm = this
            vm.$refs.uploadLicense.remove(newFile)
          } else {
            newFile = this.$refs.uploadLicense.update(newFile, { error: 'size' })
          }
        }
      }

      if (!newFile && oldFile) {
        // remove

      }
      // Automatically activate upload
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (this.uploadAuto && !this.$refs.uploadLicense.active) {
          this.$refs.uploadLicense.active = true
        }
      }
    },
    triggerSelectFile () {
      $('#selectFileLicense').click()
    },
    clickUpload () {
      if (!this.reason) {
        return
      }
      if (!this.files || !this.files.length) {
        axios.post('/doctor/deactivate-epcs', {
          reason: this.reason,
          doctorId: this.doctor.id,
          files: this.dataFiles
        }).then(response => {
          if (response.data.s === 200) {
            this.modal = false
          }
        }).catch(err => {
          console.log('err', err.message)
        })
      }
    },
    removeFile (index) {
      this.dataFiles.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.td-action-process {
  width: 80%;
  float: left;
}

.td-action-delete {
  width: 20%;
  float: left;
}

.td-action-delete i {
  color: red;
}

.progress-bar {
  color: #333;
}

.td-action .itemaction > a {
  margin-left: 10px;
  color: #3e3e3e;
}

.error-text {
  color: red;
}
</style>
